import styled from 'styled-components';
import { font, media } from 'style';

export default {
  Container: styled.div`
    display: flex;
    justify-content: center;

    ${media.md`
      justify-content: space-between;
    `}
  `,
  TextContainer: styled.div`
    max-width: 610px;
  `,
  Title: styled.div`
    line-height: 46px;
  `,
  SubText: styled.div`
    font-size: ${font.size.xLarge};
    margin-top: 10px;
    line-height: 31px;
  `,
  ImageContainer: styled.div<{ width: number }>`
    display: none;
    max-width: ${({ width }) => width}px;
    min-width: 300px;
    margin-left: 40px;

    img {
      width: 100%;
    }

    ${media.md`
      display:flex;
      align-item: flex-end;
    `}
  `,
  ButtonContainer: styled.div`
    margin-top: 35px;
  `,
};
